import React, { useEffect, useState } from 'react';
import PhotoBook5 from "../../assets/img/PhotoBook-8x8.jpg";
import Info from "../../assets/img/info.svg";
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import projectStore from '../../stores/CanvasNameStore';
import { useNavigate } from 'react-router-dom';
import Header from '../../Components/Header';
import { observer } from 'mobx-react-lite';

const headerLinks = [{ name: "Home", href: "/" }];

const schema = yup.object().shape({
  projectName: yup
    .string()
    .required('Project Name is required')
    .max(50, 'Project Name must be 50 characters or less'),
  description: yup
    .string()
    .max(300, 'Description must be 300 characters or less'),
});

// Interface matches the yup schema
interface FormValues {
  projectName: string;
  description?: string;
}

const CanvasProjectName: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    mode: 'onSubmit',
  });

  const watchFields = watch();

  useEffect(() => {
    setErrorMessage('');
  }, [watchFields]);

  const onSubmit = (data: FormValues) => {
    console.log(data);
    projectStore.setProjectDetails({
      projectName: data.projectName,
      description: data.description || '',
    });
    toast.success('Form submitted successfully', {
      position: 'top-right',
    });
    setTimeout(() => {
      navigate('/canvas', { replace: true });
    }, 2000);
    console.log('Form Submitted: ', data);
  };

  return (
    <>
      <Header cartItemsCount={0} title="My Website" links={headerLinks} />
      <div>
        <section className="YourProjectDetails ">
          <div className="mx-auto max-w-7xl mt-10 mb-40 px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-normal text-left">
              Name your Canvas Project
            </h1>
            <p className="text-sm text-gray-700 mt-3">
              To stay organized and make it easier to re-order this project in
              the future
            </p>

            <form
              onSubmit={handleSubmit(onSubmit)}
              className="grid grid-cols-6 gap-4 mt-10"
            >
              <div className=" ">
                <div className="p-3 mt-2 border-gray-200 border shadow-md rounded-lg">
                  <img
                    src={PhotoBook5}
                    alt="Xceedprintsolutions"
                    className="h-38 w-auto"
                  />
                </div>
              </div>

              <div className="col-start-2 col-span-3 pl-5 pr-10">
                <div className="pb-2">
                  <label
                    htmlFor="projectName"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Project Name <label className="text-gray-400"> </label>
                  </label>
                  <div className="relative mt-2 rounded-md shadow-sm">
                    <input
                      id="projectName"
                      type="text"
                      {...register('projectName')}
                      className="mt-1 block w-full p-3 text-sm border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter Project name"
                    />
                    {errors.projectName && (
                      <p className="text-red-500">{errors.projectName.message}</p>
                    )}
                  </div>
                </div>

                <div className="mt-4">
                  <label
                    htmlFor="description"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Add a description <label className="text-gray-400"> </label>
                  </label>
                  <textarea
                    id="description"
                    {...register('description')}
                    placeholder="Enter project description"
                    className="block w-full h-32 p-3 text-sm border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  />
                  {errors.description && (
                    <p className="text-red-500">{errors.description?.message}</p>
                  )}
                </div>

                <button
                  type="submit"
                  className="w-full mt-6 py-2 px-4 bg-green font-medium text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                >
                  NEXT
                </button>
              </div>
            </form>

          </div>
        </section>
      </div>
    </>
  );
};

export default observer(CanvasProjectName);
